<template onload="closeWindow();">
<div id="wrapper" style="text-align:center; width:100%; height:100%;">
<h1>您尚未绑定！</h1>
<div id="show" style="text-align:center; width:100%; height:100%;">  
  将倒计时<font color=red>({{count}}s)</font>秒后跳转至绑定界面！
</div>
</div>
</template>


<script>
import wx from 'weixin-js-sdk'
export default {
    data(){
        return {
            count:"5",//倒计时
        }
    },
 
created(){

   this.threeGo();
},
 
methods: {
  //3秒后进入跳转页面
    threeGo(){
		const TIME_COUNT = 3;
		if(!this.timer){
			this.count = TIME_COUNT;
			this.show = false;
			this.timer = setInterval(()=>{
			if(this.count > 0 && this.count <= TIME_COUNT){
				this.count--;
			}else{
				this.show = true;
				clearInterval(this.timer);
				this.timer = null;
				//跳转的页面写在此处
			 this.$router.push({path: '/HelloWorld'});
						   
			}
		  },1000)
		}
    }
          }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeTimer.vue